module.exports = __webpack_public_path__ + "img/bn.0f175fa2.svg";